export default __webpack_public_path__ + "static/media/redirect.55261664.svg";